import LdsAccordionToggle from './components/LdsAccordionToggle/index.js';
import LdsAskLillyLogo from './components/LdsAskLillyLogo/index.js';
import LdsButtonGroupToggle from './components/LdsButtonGroupToggle/index.js';
import LdsFigureCaption from './components/LdsFigureCaption/index.js';
import LdsFooter from './components/LdsFooter/index.js';
import LdsHorizontalRule from './components/LdsHorizontalRule/index.js';
import LdsIcon from './components/LdsIcon/index.js';
import LdsLillyLogo from './components/LdsLillyLogo/index.js';
import LdsLink from './components/LdsLink/index.js';
import LdsLoadingSpinner from './components/LdsLoadingSpinner/index.js';
import LdsNumericSlider from './components/LdsNumericSlider/index.js';
import LdsProgressIndicator from './components/LdsProgressIndicator/index.js';
import LdsSkipToMain from './components/LdsSkipToMain/index.js';
import LdsTooltip from './components/LdsTooltip/index.js';

export function defineLdsComponents() {
  LdsAccordionToggle.defineComponent();
  LdsAskLillyLogo.defineComponent();
  LdsButtonGroupToggle.defineComponent();
  LdsFigureCaption.defineComponent();
  LdsFooter.defineComponent();
  LdsHorizontalRule.defineComponent();
  LdsIcon.defineComponent();
  LdsLillyLogo.defineComponent();
  LdsLink.defineComponent();
  LdsLoadingSpinner.defineComponent();
  LdsNumericSlider.defineComponent();
  LdsProgressIndicator.defineComponent();
  LdsSkipToMain.defineComponent();
  LdsTooltip.defineComponent();
}
